import { find } from 'lodash';

interface GuardProps extends React.PropsWithChildren {
    requiredRoles: string[];
    currentRoles: string[];
}

function checkRole(requiredRoles: string[], userRoles: string[]): boolean {
    let found: string | undefined = find(userRoles, e => requiredRoles.includes(e));
    return found !== undefined;
}

function Guard({ requiredRoles, currentRoles, children }: GuardProps) {
    return <>{children}</>;
    if (checkRole(requiredRoles, currentRoles)) {
        return <>{children}</>;
    } else {
        return <></>
    }
}

export default Guard;
